import { defineMessages } from "react-intl";

export const messages = defineMessages({
  buttonLabel: {
    id: "button.goToDashboard.label",
    defaultMessage: "Send invitation",
    description: "Button label go to dashboard page",
  },
});
